import axios from "axios";
export default {
  install(Vue, { store, router, ElementUI }) {
    let lastSeq = 0;
    let globalListener;
    let petCb = [];
    let userCb = [];
    let recordCb = [];
    let bookingCb = [];
    let reminderCb = [];
    let inHospitalCb = [];
    let deviceExamCb = [];
    let recordExamCb = [];
    //use socket change white list
    // let socketClinic = [];

    let lastError = 0;
    let tag = "[changePlugin]";
    Vue.prototype.$change = {
      registerGlobal: async function (currentRoute) {
        this.unregisterGlobal();
        // socketClinic = (await window.NxVetV2.getSocketChangeWhiteList()).result;
        // if (socketClinic.indexOf(localStorage.getItem("CLINIC")) > -1) {
        console.log(tag, "use socket change");
        socketChange();
        window.NxVetSocket.addConnectionListener(socketConnectListener);
        // } else {
        //   console.log(tag, "use polling change");
        //   globalChange();
        // }
        console.log(`[${tag}] currentRoute:${currentRoute}`);
        store.dispatch("change/actionPetInited", false);
        store.dispatch("change/actionUserInited", false);

        let executeOrder = [initBasic];
        switch (currentRoute) {
          case "User":
          case "UserDetail":
          case "Pets":
          case "Record":
            // executeOrder.push(initUserPet);
            executeOrder.push(initToday);
            executeOrder.push(initTodo);
            executeOrder.push(initSynctool);
            executeOrder.push(initReminder);
            break;
          case "ScheduleTodo":
            executeOrder.push(initTodo);
            executeOrder.push(initToday);
            // executeOrder.push(initUserPet);
            executeOrder.push(initSynctool);
            executeOrder.push(initReminder);
            break;
          case "ReminderIndex":
            executeOrder.push(initReminder);
            executeOrder.push(initToday);
            executeOrder.push(initTodo);
            // executeOrder.push(initUserPet);
            executeOrder.push(initSynctool);
            break;
          case "ScheduleOverview":
            executeOrder.push(initToday);
            executeOrder.push(initTodo);
            // executeOrder.push(initUserPet);
            executeOrder.push(initSynctool);
            executeOrder.push(initReminder);
            break;
          case "TodayRecord":
          case "TodayCheckIn":
          case "TodayCheckout":
            executeOrder.push(initToday);
            // executeOrder.push(initUserPet);
            executeOrder.push(initTodo);
            executeOrder.push(initSynctool);
            executeOrder.push(initReminder);
            break;
          case "TodayTodoExam":
          case "TodayTodoDispense":
            executeOrder.push(initTodo);
            // executeOrder.push(initUserPet);
            executeOrder.push(initToday);
            executeOrder.push(initSynctool);
            executeOrder.push(initReminder);
            break;
          case "SyncTool":
            executeOrder.push(initSynctool);
            executeOrder.push(initToday);
            executeOrder.push(initTodo);
            // executeOrder.push(initUserPet);
            executeOrder.push(initReminder);
            break;
          default:
            executeOrder.push(initToday);
            executeOrder.push(initTodo);
            // executeOrder.push(initUserPet);
            executeOrder.push(initSynctool);
            executeOrder.push(initReminder);
        }
        let errorMsg = "";
        for (let promise of executeOrder) {
          errorMsg += await promise();
        }
        console.log("errorMsg1", errorMsg);
        if (errorMsg !== "") {
          errorMsg = errorMsg.substring(0, errorMsg.length - 1);
          ElementUI.Message({
            showClose: true,
            type: "error",
            message: `系統維護中，請稍候重新整理，取得最新資料`,
            // message: `網路連線不穩，${errorMsg}取得失敗，請稍候重新整理，以取得最新資料`,
          });
          window.NxVetV2.webLog({
            error: "initial fail:" + errorMsg,
          });
        }
      },
      unregisterGlobal: () => {
        // console.log("unregister first");
        store.dispatch("change/actionReset");

        // if (socketClinic.indexOf(localStorage.getItem("CLINIC")) > -1) {
        window.NxVetSocket.removeConnectionListener(socketConnectListener);
        while (changeEmitterQueue.length) {
          const ce = changeEmitterQueue.shift();
          if (ce) {
            ce.cancel();
          }
        }
        window.NxVetSocket.drop();
        // } else {
        //   if (globalListener) {
        //     console.log(tag, `unregisterGlobal`);
        //     globalListener.cancel();
        //     globalListener = null;
        //   }

        //   lastSeq = 0;
        //   lastError = 0;
        // }

        petCb = [];
        userCb = [];
        recordCb = [];
        bookingCb = [];
        reminderCb = [];
        inHospitalCb = [];
        deviceExamCb = [];
        recordExamCb = [];
      },
      addPetListener: (cb) => {
        if (typeof cb === "function") {
          petCb.push(cb);
        }
      },
      removePetListener: (cb) => {
        const index = petCb.indexOf(cb);
        if (index > -1) {
          petCb.splice(index, 1);
        }
      },
      addUserListener: (cb) => {
        if (typeof cb === "function") {
          userCb.push(cb);
        }
      },
      removeUserListener: (cb) => {
        const index = userCb.indexOf(cb);
        if (index > -1) {
          userCb.splice(index, 1);
        }
      },
      addRecordListener: (cb) => {
        if (typeof cb === "function") {
          recordCb.push(cb);
        }
      },
      getRecordListener: () => {
        return recordCb.length;
      },
      removeRecordListener: (cb) => {
        const index = recordCb.indexOf(cb);
        if (index > -1) {
          recordCb.splice(index, 1);
        }
      },
      addBookingListener: (cb) => {
        if (typeof cb === "function") {
          bookingCb.push(cb);
        }
      },
      removeBookingListener: (cb) => {
        const index = bookingCb.indexOf(cb);
        if (index > -1) {
          bookingCb.splice(index, 1);
        }
      },
      addReminderListener: (cb) => {
        if (typeof cb === "function") {
          reminderCb.push(cb);
        }
      },
      removeReminderListener: (cb) => {
        const index = reminderCb.indexOf(cb);
        if (index > -1) {
          reminderCb.splice(index, 1);
        }
      },
      addInHospitalListener: (cb) => {
        if (typeof cb === "function") {
          inHospitalCb.push(cb);
        }
      },
      getInHospitalListener: () => {
        return inHospitalCb.length;
      },
      removeInHospitalListener: (cb) => {
        const index = inHospitalCb.indexOf(cb);
        if (index > -1) {
          inHospitalCb.splice(index, 1);
        }
      },
      addDeviceExamListener: (cb) => {
        if (typeof cb === "function") {
          deviceExamCb.push(cb);
        }
      },
      removeDeviceExamListener: (cb) => {
        const index = deviceExamCb.indexOf(cb);
        if (index > -1) {
          deviceExamCb.splice(index, 1);
        }
      },
      getDeviceExamListener: () => {
        return deviceExamCb.length;
      },
      addRecordExamListener: (cb) => {
        if (typeof cb === "function") {
          recordExamCb.push(cb);
        }
      },
      removeRecordExamListener: (cb) => {
        const index = recordExamCb.indexOf(cb);
        if (index > -1) {
          recordExamCb.splice(index, 1);
        }
      },
      getRecordExamListener: () => {
        return recordExamCb.length;
      },
    };

    let reloadBombTimeoutID;
    let reloadBombBlowUp;
    let socketConnectListener = (status, error) => {
      if (error) {
        console.log(tag, `socket connect status:` + status, error);
        // window.NxErp.saveUserIP("socket disconnect");
      } else {
        console.log(tag, `socket connect status:` + status);
        // window.NxErp.saveUserIP("socket connect");
      }
      store.dispatch("header/actionSetChangeStatus", {
        visible: status !== "connect",
      });

      if (status === "connect") {
        if (reloadBombTimeoutID) {
          clearTimeout(reloadBombTimeoutID);
          reloadBombTimeoutID = null;
        }
      } else if (status === "disconnect" && !reloadBombBlowUp) {
        reloadBombTimeoutID = setTimeout(() => {
          reloadBombBlowUp = true;
          ElementUI.MessageBox.alert(
            "系統有更新資料，請按下確定鈕重新整理頁面",
            "重新整理通知",
            {
              showClose: false,
              confirmButtonText: "確定",
              callback: (action) => {
                window.location.reload();
              },
            }
          );
        }, 10 * 60 * 1000);
      }
    };

    let changeEmitterQueue = [];
    let socketChange = () => {
      changeEmitterQueue.push(
        window.NxVetSocket.addDocChangeListener("user")
          .onCreate((data) => {
            data._rev = "1-";
            handleUserChange({ id: data._id, doc: data });
          })
          .onUpdate((data) => {
            data._rev = "2-";
            handleUserChange({ id: data._id, doc: data });
          })
          .onDelete((data) => {
            handleUserChange({ id: data._id, deleted: true });
          })
          .onStart((data) => {})
      );

      changeEmitterQueue.push(
        window.NxVetSocket.addDocChangeListener("pet")
          .onCreate((data) => {
            data._rev = "1-";
            handlePetChange({
              id: data._id,
              doc: data,
            });
          })
          .onUpdate((data) => {
            data._rev = "2-";
            handlePetChange({
              id: data._id,
              doc: data,
            });
          })
          .onDelete((data) => {
            handlePetChange({
              id: data._id,
              deleted: true,
            });
          })
          .onStart((data) => {})
      );
      changeEmitterQueue.push(
        window.NxVetSocket.addDocChangeListener("staff")
          .onCreate((data) => {
            data._rev = "1-";
            handleStaffChange({
              id: data._id,
              doc: data,
            });
          })
          .onUpdate((data) => {
            data._rev = "2-";
            handleStaffChange({
              id: data._id,
              doc: data,
            });
          })
          .onDelete((data) => {
            handleStaffChange({
              id: data._id,
              deleted: true,
            });
          })
          .onStart((data) => {})
      );

      changeEmitterQueue.push(
        window.NxVetSocket.addDocChangeListener("record")
          .onCreate((data) => {
            data._rev = "1-";
            handleRecordChange({
              id: data._id,
              doc: data,
            });
          })
          .onUpdate((data) => {
            data._rev = "2-";
            handleRecordChange({
              id: data._id,
              doc: data,
            });
          })
          .onDelete((data) => {
            handleRecordChange({
              id: data._id,
              deleted: true,
            });
          })
          .onStart((data) => {})
      );

      changeEmitterQueue.push(
        window.NxVetSocket.addDocChangeListener("booking")
          .onCreate((data) => {
            data._rev = "1-";
            handleBookingChange({
              id: data._id,
              doc: data,
            });
          })
          .onUpdate((data) => {
            data._rev = "2-";
            handleBookingChange({
              id: data._id,
              doc: data,
            });
          })
          .onDelete((data) => {
            handleBookingChange({
              id: data._id,
              deleted: true,
            });
          })
          .onStart((data) => {})
      );

      changeEmitterQueue.push(
        window.NxVetSocket.addDocChangeListener("inHospital")
          .onCreate((data) => {
            data._rev = "1-";
            handleInHospitalChange({
              id: data._id,
              doc: data,
            });
          })
          .onUpdate((data) => {
            data._rev = "2-";
            handleInHospitalChange({
              id: data._id,
              doc: data,
            });
          })
          .onDelete((data) => {
            handleInHospitalChange({
              id: data._id,
              deleted: true,
            });
          })
          .onStart((data) => {})
      );

      changeEmitterQueue.push(
        window.NxVetSocket.addDocChangeListener("role")
          .onCreate((data) => {
            data._rev = "1-";
            handleRoleChange({
              id: data._id,
              doc: data,
            });
          })
          .onUpdate((data) => {
            data._rev = "2-";
            handleRoleChange({
              id: data._id,
              doc: data,
            });
          })
          .onDelete((data) => {
            handleRoleChange({
              id: data._id,
              deleted: true,
            });
          })
          .onStart((data) => {})
      );

      changeEmitterQueue.push(
        window.NxVetSocket.addDocChangeListener("reminder")
          .onCreate((data) => {
            data._rev = "1-";
            handleReminderChange({
              id: data._id,
              doc: data,
            });
          })
          .onUpdate((data) => {
            data._rev = "2-";
            handleReminderChange({
              id: data._id,
              doc: data,
            });
          })
          .onDelete((data) => {
            handleReminderChange({
              id: data._id,
              deleted: true,
            });
          })
          .onStart((data) => {})
      );
      changeEmitterQueue.push(
        window.NxVetSocket.addDocChangeListener("synctool")
          .onCreate((data) => {
            data._rev = "1-";
            handleSynctoolChange({
              id: data._id,
              doc: data,
            });
          })
          .onUpdate((data) => {
            data._rev = "2-";
            handleSynctoolChange({
              id: data._id,
              doc: data,
            });
          })
          .onDelete((data) => {
            handleSynctoolChange({
              id: data._id,
              deleted: true,
            });
          })
          .onStart((data) => {})
      );
      changeEmitterQueue.push(
        window.NxVetSocket.addDocChangeListener("setting")
          .onCreate((data) => {
            data._rev = "1-";
            if (data._id.startsWith("/setting/treatment")) {
              handleTreatmentSettingChange({
                id: data._id,
                doc: data,
              });
            } else {
              handleSettingChange({
                id: data._id,
                doc: data,
              });
            }
          })
          .onUpdate((data) => {
            data._rev = "2-";
            if (data._id.startsWith("/setting/treatment")) {
              handleTreatmentSettingChange({
                id: data._id,
                doc: data,
              });
            } else {
              handleSettingChange({
                id: data._id,
                doc: data,
              });
            }
          })
          .onDelete((data) => {
            if (data._id.startsWith("/setting/treatment")) {
              handleTreatmentSettingChange({
                id: data._id,
                deleted: true,
              });
            } else {
              handleSettingChange({
                id: data._id,
                deleted: true,
              });
            }
          })
          .onStart((data) => {})
      );
      changeEmitterQueue.push(
        window.NxVetSocket.addDocChangeListener("exam")
          .onCreate((data) => {
            data._rev = "1-";
            if (data._id.startsWith("/exam/device")) {
              handleDeviceExamChange({
                id: data._id,
                doc: data,
              });
            }
            // else if (data._id.startsWith("/exam/record")) {
            //   console.log('changed:create')
            //   handleRecordExamChange({
            //     id: data._id,
            //     doc: data,
            //   });
            // }
          })
          .onUpdate((data) => {
            data._rev = "2-";
            if (data._id.startsWith("/exam/device")) {
              handleDeviceExamChange({
                id: data._id,
                doc: data,
              });
            } else if (data._id.startsWith("/exam/record")) {
              // console.log('changed:update')
              handleRecordExamChange({
                id: data._id,
                doc: data,
              });
            }
          })
          .onDelete((data) => {
            if (data._id.startsWith("/exam/device")) {
              handleDeviceExamChange({
                id: data._id,
                deleted: true,
              });
            } else if (data._id.startsWith("/exam/record")) {
              handleRecordExamChange({
                id: data._id,
                deleted: true,
              });
            }
          })
          .onStart((data) => {})
      );
      changeEmitterQueue.push(
        window.NxVetSocket.addDocChangeListener("verify")
          .onCreate((data) => {
            data._rev = "1-";
            handleVerifyChange({
              id: data._id,
              doc: data,
            });
          })
          .onUpdate((data) => {
            data._rev = "2-";
            handleVerifyChange({
              id: data._id,
              doc: data,
            });
          })
          .onDelete((data) => {
            handleVerifyChange({
              id: data._id,
              deleted: true,
            });
          })
          .onStart((data) => {})
      );
    };

    // let globalChange = () => {
    //   let since = lastSeq > 0 ? lastSeq : "now";
    //   console.log(
    //     tag,
    //     `create global change[${localStorage.getItem("CLINIC")}] since:` + since
    //   );

    //   if (globalListener) {
    //     console.log(tag, `cancel exist change link`);
    //     globalListener.cancel();
    //     globalListener = null;
    //   }

    //   let _this = this;
    //   globalListener = window.NxVet.changes({
    //     live: true,
    //     include_docs: true,
    //     since: since,
    //     filter: "myfilter",
    //     query_params: {
    //       prefix:
    //         "/user/,/pet/,/staff/,/record/,/booking/,/inHospital/,/role/,/reminder/,/synctool/",
    //       match: "/setting",
    //       clinic: localStorage.getItem("CLINIC"),
    //       account: store.state.user.user.account,
    //     },
    //   })
    //     .on("change", (change) => {
    //       // handle change
    //       // console.log("#change:" + JSON.stringify(change));
    //       lastSeq = change.seq;
    //       if (change.id.startsWith("/user/")) {
    //         handleUserChange(change);
    //       } else if (change.id.startsWith("/pet/")) {
    //         handlePetChange(change);
    //       } else if (change.id.startsWith("/staff/")) {
    //         handleStaffChange(change);
    //       } else if (change.id.startsWith("/record/")) {
    //         handleRecordChange(change);
    //       } else if (change.id.startsWith("/booking/")) {
    //         handleBookingChange(change);
    //       } else if (change.id === "/setting") {
    //         handleSettingChange(change);
    //       } else if (change.id === "/setting/treatment") {
    //         handleTreatmentSettingChange(change);
    //       } else if (change.id.startsWith("/inHospital/")) {
    //         handleInHospitalChange(change);
    //       } else if (change.id.startsWith("/role/")) {
    //         handleRoleChange(change);
    //       } else if (change.id.startsWith("/reminder/")) {
    //         handleReminderChange(change);
    //       } else if (change.id.startsWith("/synctool/")) {
    //         handleSynctoolChange(change);
    //       }
    //     })
    //     .on("complete", (info) => {
    //       // changes() was canceled
    //       // console.log("#complete:" + JSON.stringify(info));
    //     })
    //     .on("error", (err) => {
    //       // console.log("now: " + window.dayjs().unix());
    //       // console.log("lastError: " + lastError);
    //       console.error(tag, `change error: ${JSON.stringify(err)}`);
    //       if (err.error === "unauthorized") {
    //         ElementUI.Message({
    //           showClose: true,
    //           message: "您的密碼已被更新，請重新登入系統",
    //           type: "warning",
    //         });
    //         router.push("/logout");
    //         return;
    //       }
    //       /**
    //        * 斷線原因例如：
    //        * 1. DB重啟原先持有憑證失效
    //        * 2. DB連線中斷
    //        * 3  socket固定120s的規律中斷
    //        */

    //       if (window.dayjs().unix() - lastError > 100) {
    //         //假設距離上次中斷連線已經是100s以前的事件，則先檢查登入狀態再重新連線
    //         window.NxVet.checkConnection(true).then(
    //           () => {
    //             //if user still login
    //             globalChange();
    //           },
    //           (error) => {
    //             console.error(tag, `check login failure`, error);
    //             changeConnectRetry(10);
    //           }
    //         );
    //       } else {
    //         console.error(
    //           tag,
    //           `change break too fast，stop create new connect`
    //         );
    //         changeConnectRetry(10);
    //       }
    //       lastError = window.dayjs().unix();
    //     });
    // };

    let handleUserChange = (change) => {
      //is user
      if (change.deleted) {
        //delete user
        store.dispatch("change/actionDeleteUser", change.id);
        userCb.forEach((cb) => {
          cb(change.id, {});
        });
      } else if (change.doc._rev.startsWith("1-")) {
        //add user
        store.dispatch("change/actionAddUser", change.doc);
        userCb.forEach((cb) => {
          cb(change.id, JSON.parse(JSON.stringify(change.doc)));
        });
      } else {
        //update user
        store.dispatch("change/actionUpdateUser", change.doc);
        userCb.forEach((cb) => {
          cb(change.id, JSON.parse(JSON.stringify(change.doc)));
        });
      }
    };
    let handlePetChange = (change) => {
      //is pet
      if (change.deleted) {
        //delete pet
        store.dispatch("change/actionDeletePet", change.id);
        store.dispatch("change/actionDeleteCheckData", change.id);
        petCb.forEach((cb) => {
          cb(change.id, {});
        });
      } else if (change.doc._rev.startsWith("1-")) {
        //add pet
        store.dispatch("change/actionAddPet", change.doc);
        store.dispatch("change/actionAddCheckData", change.doc);
        petCb.forEach((cb) => {
          cb(change.id, JSON.parse(JSON.stringify(change.doc)));
        });
      } else {
        //update pet
        store.dispatch("change/actionUpdatePet", change.doc);
        store.dispatch("change/actionUpdateCheckData", change.doc);
        petCb.forEach((cb) => {
          cb(change.id, JSON.parse(JSON.stringify(change.doc)));
        });
      }
    };
    let handleStaffChange = (change) => {
      //is staff
      if (change.deleted) {
        //delete staff
        store.dispatch("change/actionDeleteStaff", change.id);
      } else if (change.doc._rev.startsWith("1-")) {
        //add staff
        store.dispatch("change/actionAddStaff", change.doc);
      } else {
        //update staff
        store.dispatch("change/actionUpdateStaff", change.doc);
      }
    };
    let handleRecordChange = async (change) => {
      //is record
      if (change.deleted) {
        //delete record
        recordCb.forEach((cb) => {
          cb(change.id, {});
        });
        store.dispatch("change/actionDeleteTodayRecord", change.id);
        store.dispatch("change/deleteExamTodo", change.id);
        store.dispatch("change/deleteDispenseTodo", change.id);
        store.dispatch("change/actionDeleteWaiting", change.id);
        store.dispatch("change/actionDeleteHistoryUndoneRecord", change.id);
        //store.dispatch("change/actionDeleteHistoryUndoneBill", change.id);
      } else if (change.doc._rev.startsWith("1-")) {
        //add record
        recordCb.forEach((cb) => {
          cb(change.id, JSON.parse(JSON.stringify(change.doc)));
        });
        store.dispatch("change/actionAddTodayRecord", change.doc);
      } else if (change.doc?.type === "abaxis") {
        // 儲存檢驗PDF到病例附件
        console.log("abaxis PDF", change);

        const pdfUrl = change.doc.url;
        const auth = {
          username: "admin",
          password: "admin",
        };
        if (pdfUrl.match("sandbox")) {
          auth.username = "b27c3c23-0fd2-4963-9d4c-bdd1868d5a3f";
          auth.password =
            "43544b33cccb71655a8fd7861e318e4e2b70008109af3fc6cf455e1ead0a724dd15c06";
        }
        try {
          // ==== get PDF file ====
          // note: basic auth(admin/admin)
          // download PDF file, use responseType 'arraybuffer' to get data
          const response = await window.NxVetV2.getAbaxisPdf({
            pdfUrl,
            auth,
          });
          const buffer = response.result.data;
          let pdfBuffer;
          if (buffer) {
            pdfBuffer = new ArrayBuffer(buffer.length);
            const view = new Uint8Array(pdfBuffer);
            for (let i = 0; i < buffer.length; ++i) {
              view[i] = buffer[i];
            }
          }
          if (!pdfBuffer) throw { message: "pdfBuffer is not exist" };

          // ==== create blob and turn to buffer ====
          const pdfBlob = new Blob([pdfBuffer], { type: "application/pdf" });
          const pdfFile = new File([pdfBlob], "exam_result.pdf", {
            type: "application/pdf",
          });

          // ==== create formData append file ====
          let formData = {};
          formData[`therapyFile-0`] = pdfFile;

          // ==== send request ====
          // SDK: uploadRecordFile(recordID, upload, taskID = null)
          // API: {Post} /sdk/v2/:clinic/record/:id/file/taskID? 新增病歷附件
          const uploadResponse = await window.NxVetV2.uploadRecordFile(
            change.doc._id,
            formData
          );

          console.log(uploadResponse.data);
        } catch (error) {
          console.error("Error downloading or uploading PDF:", error);
        }
      } else {
        //update record
        recordCb.forEach((cb) => {
          cb(change.id, JSON.parse(JSON.stringify(change.doc)));
        });
        store.dispatch("change/actionUpdateTodayRecord", change.doc);
      }
    };
    let handleBookingChange = (change) => {
      //is booking
      if (change.deleted) {
        //delete booking
        bookingCb.forEach((cb) => {
          cb(change.id, {});
        });
        store.dispatch("change/actionDeleteTodayBooking", change.id);
        store.dispatch("change/actionDeleteCheckBooking", change.id);
      } else if (change.doc._rev.startsWith("1-")) {
        //add booking
        bookingCb.forEach((cb) => {
          cb(change.id, JSON.parse(JSON.stringify(change.doc)));
        });
        store.dispatch("change/actionAddTodayBooking", change.doc);
        store.dispatch("change/actionAddCheckBooking", change.doc);
      } else {
        //update booking
        bookingCb.forEach((cb) => {
          cb(change.id, JSON.parse(JSON.stringify(change.doc)));
        });
        store.dispatch("change/actionUpdateTodayBooking", change.doc);
        store.dispatch("change/actionUpdateCheckBooking", change.doc);
      }
    };
    let handleSettingChange = (change) => {
      store.dispatch("change/actionSetSetting", change.doc);
    };
    let handleTreatmentSettingChange = (change) => {
      console.log("#TreatmentSettingChange", JSON.stringify(change.doc));

      store.dispatch("change/actionSetTreatmentSetting", change.doc);
    };
    let handleInHospitalChange = (change) => {
      // console.log("#handleInHospitalChange", JSON.stringify(change.doc));
      //is inHospital
      if (change.deleted) {
        //delete inHospital
        inHospitalCb.forEach((cb) => {
          cb(change.id, {});
        });
        store.dispatch("change/actionDeleteTodayInHospital", change.id);
        store.dispatch("change/actionDeleteInHospitalTodo", change.id);
        store.dispatch("change/actionDeleteInHospitalBilling", change.id);
      } else if (change.doc._rev.startsWith("1-")) {
        //add inHospital
        inHospitalCb.forEach((cb) => {
          cb(change.id, JSON.parse(JSON.stringify(change.doc)));
        });

        store.dispatch("change/actionAddTodayInHospital", change.doc);
      } else {
        //update inHospital
        inHospitalCb.forEach((cb) => {
          cb(change.id, JSON.parse(JSON.stringify(change.doc)));
        });
        store.dispatch("change/actionUpdateTodayInHospital", change.doc);
      }
    };
    let handleRoleChange = (change) => {
      //is role
      if (change.deleted) {
        //delete role
        store.dispatch("change/actionDeleteRole", change.id);
      } else if (change.doc._rev.startsWith("1-")) {
        //add role
        store.dispatch("change/actionAddRole", change.doc);
      } else {
        //update role
        store.dispatch("change/actionUpdateRole", change.doc);
      }
    };

    let handleReminderChange = (change) => {
      // console.log(JSON.stringify(change));
      if (change.deleted) {
        store.dispatch("change/actionDeleteReminder", change.id);
        reminderCb.forEach((cb) => {
          cb(change.id, {});
        });
      } else {
        store.dispatch("change/actionUpdateReminder", change.doc);
        reminderCb.forEach((cb) => {
          cb(change.id, JSON.parse(JSON.stringify(change.doc)));
        });
      }
    };

    let handleSynctoolChange = (change) => {
      //is role
      if (change.deleted) {
        //delete role
        store.dispatch("change/actionDeleteSynctool", change.id);
      } else if (change.doc._rev.startsWith("1-")) {
        //add role
        store.dispatch("change/actionAddSynctool", change.doc);
      } else {
        //update role
        store.dispatch("change/actionUpdateSynctool", change.doc);
      }
    };

    let handleDeviceExamChange = (change) => {
      //is exam
      if (change.deleted) {
        //delete exam
        store.dispatch("change/actionDeleteDeviceExam", change.id);
        deviceExamCb.forEach((cb) => {
          cb(change.id, {});
        });
      } else if (change.doc._rev.startsWith("1-")) {
        //add exam
        store.dispatch("change/actionAddDeviceExam", change.doc);
        deviceExamCb.forEach((cb) => {
          cb(change.id, JSON.parse(JSON.stringify(change.doc)));
        });
      } else {
        //update exam
        store.dispatch("change/actionUpdateDeviceExam", change.doc);
        deviceExamCb.forEach((cb) => {
          cb(change.id, JSON.parse(JSON.stringify(change.doc)));
        });
      }
    };

    let handleRecordExamChange = (change) => {
      // console.log('[exam change console]')
      //is exam
      if (change.deleted) {
        //delete exam
        store.dispatch("change/actionDeleteRecordExam", change.id);
        recordExamCb.forEach((cb) => {
          cb(change.id, {});
        });
      } else if (change.doc._rev.startsWith("1-")) {
        //add exam
        // console.log('[addExamChange]')
        store.dispatch("change/actionAddRecordExam", change.doc);
        recordExamCb.forEach((cb) => {
          cb(change.id, JSON.parse(JSON.stringify(change.doc)));
        });
      } else {
        //update exam
        // console.log('[updateExamChange]')
        store.dispatch("change/actionUpdateRecordExam", change.doc);
        recordExamCb.forEach((cb) => {
          cb(change.id, JSON.parse(JSON.stringify(change.doc)));
        });
      }
    };
    let handleVerifyChange = (change) => {
      //is verify
      if (change.deleted) {
        //delete verify
        recordCb.forEach((cb) => {
          cb(change.id, {});
        });
        store.dispatch("change/deleteVerifyTodo", change.id);
      } else if (change.doc._rev.startsWith("1-")) {
        //add record
        recordCb.forEach((cb) => {
          cb(change.id, JSON.parse(JSON.stringify(change.doc)));
        });
        store.dispatch("change/addVerifyTodo", change.doc);
      } else {
        //update record
        recordCb.forEach((cb) => {
          cb(change.id, JSON.parse(JSON.stringify(change.doc)));
        });
        store.dispatch("change/updateVerifyTodo", change.doc);
      }
    };

    let initBasic = () =>
      new Promise((resolve) => {
        console.log(tag, `initBasic`);
        Promise.all([
          window.NxVetV2.getStaffList({ all: true }),
          window.NxVetV2.getSetting(),
          window.NxVetV2.getTreatmentSetting(),
          window.NxVetV2.getRoleList(),
        ])
          .then((res) => {
            if (res[0].code === 100000) {
              store.dispatch("change/actionSetStaff", res[0].result);
            }
            if (res[1].code === 100000) {
              store.dispatch("change/actionSetSetting", res[1].result);
            }
            if (res[2].code === 100000) {
              store.dispatch("change/actionSetTreatmentSetting", res[2].result);
            }
            if (res[3].code === 100000) {
              store.dispatch("change/actionSetRoles", res[3].result);
            }
            resolve("");
          })
          .catch((error) => {
            console.error(error);
            // ElementUI.Message({
            //   showClose: true,
            //   type: "error",
            //   message: "初始化預設資料失敗，請重新整理頁面",
            // });
            resolve("預設資料、");
          });
      });

    let initToday = () => {
      let date = window.dayjs();
      let todayBegin = date.startOf("date").unix();
      let todayEnd = date.endOf("date").unix();
      let recordDateBefore = date.subtract(2, "week").startOf("day").unix();
      let recordDateEnd = date.add(6, "month").endOf("day").unix();
      return new Promise((resolve) => {
        console.log(tag, `initToday`);
        Promise.all([
          window.NxVetV2.getBookingByDateRange({
            dateBegin: todayBegin,
            dateEnd: todayEnd,
          }),
          window.NxVetV2.getRecordListForInit(recordDateBefore, recordDateEnd),
          window.NxVetV2.getRecordListByDateTime(todayBegin, todayEnd),
          window.NxVetV2.getRecordByStatusUpdateDateTime(todayBegin, todayEnd),
          window.NxVetV2.getInHospitalBilling({
            begin: todayBegin,
            end: todayEnd,
          }),
          window.NxVetV2.getInHospitalBilling({
            begin: recordDateBefore,
            end: todayEnd,
          }),
          window.NxVetV2.getBookingListV2({
            bookingStatus: "pending",
          }),
          window.NxVetV2.getListPageWithQuery({
            approvalStatus: 10,
          }),
        ])
          .then((res) => {
            if (res[0].code === 100000) {
              store.dispatch(
                "change/actionSetTodayBooking",
                res[0].result.bookings
              );
            }
            if (res[1].code === 100000) {
              store.dispatch(
                "change/actionInitWaiting",
                res[1].result.filter(
                  (r) =>
                    r.archiveStatus === window.NxVetV2.archiveStatus.waiting
                )
              );
            }
            if (res[1].code === 100000) {
              store.dispatch(
                "change/actionInitHistoryUndoneRecord",
                res[1].result.filter(
                  (r) => r.archiveStatus === window.NxVetV2.archiveStatus.undone
                )
              );
            }
            if (res[1].code === 100000) {
              store.dispatch(
                "change/actionInitHistoryUndoneBill",
                res[1].result.filter(
                  (r) =>
                    r.billStatus === window.NxVetV2.executionStatus.requested
                )
              );
            }
            if (res[2].code === 100000 && res[3].code === 100000) {
              let todayRecord = res[2].result;
              res[3].result.forEach((record) => {
                let index = todayRecord.findIndex((r) => r._id === record._id);
                if (index === -1) {
                  todayRecord.push(record);
                }
              });
              store.dispatch("change/actionSetTodayRecord", todayRecord);
            }
            if (res[4].code === 100000) {
              store.dispatch("change/actionInHospitalBilling", res[4].result);
            }
            if (res[5].code === 100000) {
              // 兩個禮拜內的住院紀錄
              store.dispatch(
                "change/actionTwoWeekInHospitalBilling",
                res[5].result
              );
            }
            if (res[6].code === 100000) {
              // 待審查預約
              store.dispatch(
                "change/actionSetCheckBooking",
                res[6].result.bookings
              );
            }
            if (res[7].code === 100000) {
              // 待審查寵物
              store.dispatch("change/actionSetCheckData", res[7].result.data);
            }
            resolve("");
          })
          .catch((error) => {
            console.error(error);
            // ElementUI.Message({
            //   showClose: true,
            //   type: "error",
            //   message: "初始化今日看診資料失敗，請重新整理頁面",
            // });
            resolve("今日看診資料、");
          });
      });
    };
    let initTodo = () =>
      new Promise((resolve) => {
        console.log(tag, `initTodo`);
        let date = window.dayjs();
        let dispenseDateBegin = date.subtract(2, "week").startOf("day").unix();
        let examDateBegin = date.subtract(30, "day").startOf("day").unix();
        Promise.all([
          window.NxVetV2.getTodoRecordDrugList(dispenseDateBegin),
          // window.NxVetV2.getTodoRecordExamList(examDateBegin),
          window.NxVetV2.getTodoInHospitalDrugListVer2(dispenseDateBegin),
          window.NxVetV2.getTodoInHospitalExamListVer2(examDateBegin),
          // window.NxVetV2.lastDeviceExamList(),
          window.NxVetV2.getVerifyListByPet(),
        ])
          .then((res) => {
            if (res[0].code === 100000) {
              store.dispatch("change/initDispenseTodo", res[0].result);
            }
            // if (res[1].code === 100000) {
            //   store.dispatch("change/initExamTodo", res[1].result);
            // }
            let inHospitalTodo = [];
            if (res[1].code === 100000) {
              inHospitalTodo = inHospitalTodo.concat(res[1].result);
            }
            if (res[2].code === 100000) {
              inHospitalTodo = inHospitalTodo.concat(res[2].result);
            }
            store.dispatch("change/actionInHospitalTodo", inHospitalTodo);

            // if (res[4].code === 100000) {
            //   store.dispatch("change/actionSetDeviceExam", res[4].result);
            // }
            if (res[3].code === 100000) {
              store.dispatch("change/initVerifyTodo", res[3].result);
            }

            resolve("");
          })
          .catch((error) => {
            console.error(error);
            // ElementUI.Message({
            //   showClose: true,
            //   type: "error",
            //   message: "初始化待辦資料失敗，請重新整理頁面",
            // });
            resolve("待辦資料、");
          });
      });

    let initReminder = () =>
      new Promise((resolve) => {
        console.log(tag, `initReminder`);
        let reminderDateBegin = window
          .dayjs()
          .subtract(7, "day")
          .startOf("day")
          .unix();
        window.NxVetV2.getAllReminder(reminderDateBegin)
          .then((res) => {
            if (res.code === 100000) {
              store.dispatch("change/actionSetReminder", res.result);
            }
            resolve("");
          })
          .catch((error) => {
            console.error(error);
            // ElementUI.Message({
            //   showClose: true,
            //   type: "error",
            //   message: "初始化提醒資料失敗，請重新整理頁面",
            // });
            resolve("提醒資料、");
          });
      });

    // let initUserPet = () =>
    //   new Promise((resolve) => {
    //     console.log(tag, `initUserPet`);
    //     Promise.all([
    //       window.NxVetV2.getUserList({
    //         fields: store.state.change.userFields,
    //       }),
    //       window.NxVetV2.getPetList({
    //         fields: store.state.change.petFields,
    //       }),
    //     ])
    //       .then((res) => {
    //         if (res[0].code === 100000) {
    //           store.dispatch("change/actionResetUser");
    //           store.dispatch("change/actionSetUser", res[0].result);
    //           store.dispatch("change/actionUserInited", true);
    //         }
    //         if (res[1].code === 100000) {
    //           store.dispatch("change/actionResetPet");
    //           store.dispatch("change/actionSetPet", res[1].result);
    //           store.dispatch("change/actionPetInited", true);
    //         }
    //         resolve();
    //       })
    //       .catch((error) => {
    //         console.error(error);
    //         ElementUI.Message({
    //           showClose: true,
    //           type: "error",
    //           message: "初始化飼主與寵物資料失敗，請重新整理頁面",
    //         });
    //         resolve();
    //       });
    //   });

    let initSynctool = () =>
      new Promise((resolve) => {
        console.log(tag, `initSynctool`);
        window.NxVetV2.getSynctoolList()
          .then((res) => {
            if (res.code === 100000) {
              store.dispatch("change/actionSetSynctool", res.result);
            }
            resolve("");
          })
          .catch((error) => {
            console.error(error);
            // ElementUI.Message({
            //   showClose: true,
            //   type: "error",
            //   message: "初始化同步裝置失敗，請重新整理頁面",
            // });
            resolve("同步裝置、");
          });
      });

    // let changeRetryTimer;
    // let changeConnectRetry = (second) => {
    //   console.log(tag, `changeConnectRetry: ${second}`);
    //   if (changeRetryTimer) {
    //     return;
    //   }

    //   store.dispatch("header/actionSetChangeStatus", { visible: true, second });
    //   changeRetryTimer = setInterval(async () => {
    //     if (second > 0) {
    //       second--;
    //       console.log(tag, `changeConnectRetry: ${second}`);
    //       store.dispatch("header/actionSetChangeStatus", {
    //         visible: true,
    //         second,
    //       });
    //     } else {
    //       if (changeRetryTimer) {
    //         clearInterval(changeRetryTimer);
    //         changeRetryTimer = null;
    //         console.log(tag, `check connectin for change`);
    //         store.dispatch("header/actionSetChangeStatus", {
    //           visible: true,
    //           repairing: true,
    //         });
    //         window.NxVet.checkConnection(true)
    //           .then(() => {
    //             //檢測連線成功，才重新建立change
    //             store.dispatch("header/actionSetChangeStatus", {
    //               visible: false,
    //             });
    //             globalChange();
    //           })
    //           .catch((error) => {
    //             //除非檢測原因為是DB斷線才會持續嘗試連線
    //             console.log(tag, `error`, error);

    //             if (error && !Object.keys(error).length) {
    //               console.log(tag, `database offline retry later`);
    //               changeConnectRetry(10);
    //             } else {
    //               console.log(tag, `unable to repair connection`);
    //               store.dispatch("header/actionSetChangeStatus", {
    //                 visible: true,
    //               });
    //             }
    //           });
    //       }
    //     }
    //   }, 1000);
    // };
  },
};
